import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class InputCrmAnhangAttachementAdd<T extends EMode = EMode.entity> {
  /** Alias: tempFileId */
  tempFileId?: string | number;
  /** Alias: name */
  name?: string;

  __typename?: string;
}

const fields: FieldDefinitions<InputCrmAnhangAttachementAdd> = {
  tempFileId: {
    alias: 'tempFileId',
  },
  name: {
    alias: 'name',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputCrmAnhangAttachementAddEntityDefinition: EntitiyDefinition<InputCrmAnhangAttachementAdd> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputCrmAnhangAttachementAdd',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
